<template>
    <div>
        <div class="row q-col-gutter-sm">
            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                <q-select
                    v-model="emailTemplate"
                    outlined
                    :options="templates"
                    label="Template"
                    option-value="name"
                    option-label="label"
                    emit-value
                    map-options
                    color="input-color"
                    @input="updateTemplate"
                />
            </div> <!-- Email Template -->
            <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
                <q-input
                    v-model="content.user.email"
                    label="To"
                    readonly
                    color="input-color"
                />
            </div><!-- TO -->
            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                <q-select
                    v-model="emailObj.category"
                    outlined
                    :options="categories"
                    label="Category"
                    option-value="value"
                    option-label="label"
                    emit-value
                    map-options
                    color="input-color"
                    :readonly="emailObj.template !== 'blank'"
                />
            </div> <!-- Category -->
            <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
                <q-input
                    v-model="emailObj.subject"
                    label="Subject"
                    :error="emailObj.errors.has('subject')"
                    :error-message="emailObj.errors.get('subject')"
                    lazy-rules
                    :rules="[ val => !!val || 'Subject is required']"
                    color="input-color"
                />
            </div><!-- Subject -->
            <div class="col-12">
                <q-editor
                    v-model="emailObj.body"
                    ref="editor"
                    :dense="$q.screen.lt.md"
                    color="input-color"
                    :toolbar="[
                        ['fields'],
                        [
                            {
                              label: $q.lang.editor.align,
                              icon: $q.iconSet.editor.align,
                              fixedLabel: true,
                              options: ['left', 'center', 'right', 'justify']
                            }
                        ],
                        ['bold', 'italic', 'strike', 'underline'],
                        ['hr', 'link'],
                        ['foreColor', 'backColor'],
                        ['unordered', 'ordered'],
                        ['removeFormat', 'viewsource'],
                        ['undo', 'redo']
                    ]"
                >
                    <template v-slot:foreColor>
                        <q-btn
                            flat
                            no-caps
                            dense
                            style="font-size: 0.7em"
                            icon="fa fa-palette"
                        >
                            <q-tooltip>Fore color</q-tooltip>
                            <q-menu anchor="top left" self="top left">
                                <q-color v-model="foreColor" class="my-picker"></q-color>
                                <q-btn
                                    color="primary"
                                    style="width: 200px"
                                    label="Select"
                                    @click="color('foreColor', foreColor)"
                                />
                            </q-menu>
                        </q-btn>
                    </template>
                    <template v-slot:backColor>
                        <q-btn
                            flat
                            dense
                            no-caps
                            style="font-size: 0.7em"
                            icon="format_paint"
                        >
                            <q-tooltip>Back color</q-tooltip>
                            <q-menu anchor="top left" self="top left">
                                <q-color v-model="backColor" class="my-picker"></q-color>
                                <q-btn
                                    color="primary"
                                    style="width: 200px"
                                    label="Select"
                                    @click="color('backColor', backColor)"
                                />
                            </q-menu>
                        </q-btn>
                    </template>
                    <template v-slot:fields>
                        <q-btn-dropdown
                            dense no-caps
                            ref="token"
                            no-wrap
                            unelevated
                            label="Fields"
                            size="sm"
                        >
                            <q-list dense>
                                <q-item tag="label" clickable @click="add(field)" v-for="field in fields" :key="field.label">
                                    <q-item-section>{{ field.label }}</q-item-section>
                                </q-item>
                            </q-list>
                        </q-btn-dropdown>
                    </template>
                    <template v-slot:error>
                        {{ emailObj.errors.get('body') }}
                    </template>
                </q-editor>
            </div><!-- Body -->
        </div>
    </div>
</template>
<script>

import {EmailTemplatesMixin} from "./EmailTemplatesMixin"
import {mapGetters} from 'vuex'

export default {
    name: "EmailForm",
    mixins: [ EmailTemplatesMixin ],
    model: {
        prop: 'emailObj',
        event: 'change'
    },
    props: {
        emailObj: {
            type: Object,
            required: true
        },
        content: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters(['rebit_accounts'])
    },
    data() {
        return {
            emailTemplate: this.content.status,
            innerLoading: false,
            foreColor: '',
            backColor: '',
            fields: [
                {label: 'Payer first name', value: this.content.user.first_name},
                {label: 'Payer full name', value: this.content.user.name},
                {label: 'Payer address', value: this.content.user.address},
                {label: 'Ref code', value: this.content.user.ref_code},
                {label: 'Recipient name', value: this.content.recipient_name},
                {label: 'Recipient account notes', value: this.content.recipient_account_notes},
                {label: 'Recipient account number', value: this.content.recipient_account_number},
                {label: 'Recipient address', value: this.content.recipient_address},
                {label: 'Paid amount', value: (this.content.paid_amount).toString().commaSeparate()},
                {label: 'Origin currency', value: this.content.origin_currency},
                {label: 'Received amount', value: this.content.received_amount},
                {label: 'Dest currency', value: this.content.currency},
                {label: 'Country', value: this.content.country},
                {label: 'Dest country name', value: this.content.country.name.split("-")[0].trim()},
                {label: 'Reference', value: this.content.reference},
                {label: 'Particulars', value: this.content.particulars},
                {label: 'Transfer time', value: this.content.transfer_time},
                {label: 'Reason', value: this.content.reason},
            ],
            categories: [
                {label: 'Compulsory', value: 'compulsory'},
                {label: 'News', value: 'news'},
                {label: 'Offers', value: 'offers'},
                {label: 'Rates', value: 'rates'},
                {label: 'Reminders', value: 'reminders'},
            ]
        }
    },
    methods: {
        color (cmd, name) {
            const edit = this.$refs.editor
            edit.caret.restore()
            edit.runCmd(cmd, name, true)
            edit.focus()
        },
        add(field) {
            const edit = this.$refs.editor
            this.$refs.token.hide()
            edit.caret.restore()
            edit.runCmd('insertHTML', `<span>${field.value}</span>`)
            edit.focus()
        },
        updateTemplate(name) {
            const selected = this.templates.find(item => item.name === name);
            this.emailObj.subject = selected.subject.interpolate({
                reference: this.content.reference,
                origin_currency: this.content.origin_currency,
            })

            this.emailObj.body = selected.body.interpolate({
                payer_first_name: this.content.user.first_name,
                payer_name: this.content.user.name,
                payer_address: this.content.user.address,
                ref_code: this.content.user.ref_code,
                recipient_name: this.content.recipient_name,
                recipient_account_notes: this.content.recipient_account_notes,
                recipient_account_number: this.content.recipient_account_number,
                recipient_address: this.content.recipient_address,
                paid_amount: this.content.paid_amount.toString().commaSeparate(),
                origin_currency: this.content.origin_currency,
                origin_amount: this.content.origin_amount.toString().commaSeparate(),
                received_amount: this.content.received_amount.toString().commaSeparate(),
                dest_currency: this.content.currency,
                country: this.content.country,
                dest_country_name: this.content.country.name.split("-")[0].trim(),
                reference: this.content.reference,
                particulars: this.content.particulars,
                transfer_time: this.content.transfer_time,
                reason: this.content.reason
            })
        }
    },
    mounted() {
        this.updateTemplate(this.content.status)
    },
    components: {},
}
</script>
<style>

</style>
